import React, { useEffect, useState } from "react";
import { Form, Button, Icon } from "semantic-ui-react";
import { useFormik } from "formik";
import { initialValuesFour, validationSchemaFour } from "./StepFour.form";
import { VirtualScenes } from "../../../../api";
import { useAuth } from "../../../../hooks";
import { TiptapEditor } from "../../../TiptapEditor/TiptapEditor";
import "./SceneForm.scss";

const virtualSceneController = new VirtualScenes();

export function StepFour({
  formData,
  updateFormData,
  nextStep,
  prevStep,
  isUpdateMode,
  scene,
}) {
  const { accessToken } = useAuth();
  const [moduleData, setModuleData] = useState(null);

  // Cargar los datos del módulo en modo actualización
  useEffect(() => {
    async function fetchData() {
      if (isUpdateMode) {
        try {
          const data = await virtualSceneController.getVirtualScenesModeule(
            scene.refId,
            accessToken,
            "module_04",
          );
          setModuleData(data.moduleData);
        } catch (error) {
          console.error("Error fetching module data:", error);
        }
      }
    }
    fetchData();
  }, [isUpdateMode, accessToken, scene.refId]); // <-- CORREGIDO: Dependencia añadida.

  const formik = useFormik({
    initialValues: isUpdateMode
      ? initialValuesFour(moduleData)
      : initialValuesFour(formData),
    validationSchema: validationSchemaFour(),
    validateOnChange: false,
    enableReinitialize: true,
    onSubmit: async (values) => {
      try {
        let _id = "";
        if (isUpdateMode) {
          _id = scene.refId;
        } else {
          _id = localStorage.getItem("idScene");
        }

        const modulePath = "module_04";
        const response = await virtualSceneController.createModuleAdd(
          modulePath,
          accessToken,
          _id,
          values,
        );
        console.log("response", response);
      } catch (error) {
        console.error("Error al enviar el formulario:", error);
      }

      updateFormData({ ...values });
      nextStep();
    },
  });

  // EL useEffect QUE ESTABA AQUÍ HA SIDO ELIMINADO.
  // Su lógica fue movida a la función `initialValuesFour` y el `eslint-disable` fue removido.

  // Función para agregar una nueva categoría (uso de la experiencia)
  const addCategory = () => {
    formik.setFieldValue("ModFourUsescases", [
      ...formik.values.ModFourUsescases,
      { title: "", description: "" },
    ]);
  };

  // Función para eliminar una categoría
  const removeCategory = (index) => {
    const newCategories = formik.values.ModFourUsescases.filter(
      (item, i) => i !== index,
    );
    formik.setFieldValue("ModFourUsescases", newCategories);
  };

  // Función para agregar un nuevo video
  const addVideo = () => {
    formik.setFieldValue("ModFourVideo", [...formik.values.ModFourVideo, ""]);
  };

  // Función para eliminar un video
  const removeVideo = (index) => {
    const newVideos = formik.values.ModFourVideo.filter(
      (item, i) => i !== index,
    );
    formik.setFieldValue("ModFourVideo", newVideos);
  };

  return (
    <Form className="virtual-scene-form" onSubmit={formik.handleSubmit}>
      {/* Título */}
      <Form.Input
        name="ModFourTitle"
        placeholder="Título de los ejemplos de uso de la experiencia"
        onChange={formik.handleChange}
        value={formik.values.ModFourTitle}
        error={
          formik.errors.ModFourTitle
            ? { content: formik.errors.ModFourTitle }
            : null
        }
      />

      {/* Subtítulo */}
      <Form.Input
        name="ModFourSubtitle"
        placeholder="Subtítulo de los ejemplos de uso de la experiencia (opcional)"
        onChange={formik.handleChange}
        value={formik.values.ModFourSubtitle}
        error={
          formik.errors.ModFourSubtitle
            ? { content: formik.errors.ModFourSubtitle }
            : null
        }
      />

      {/* Usos de la experiencia (Categorías) */}
      <div className="usescases-container">
        <label>Usos de la experiencia</label>
        {formik.values.ModFourUsescases.map((usesCase, index) => (
          <div key={index} className="usescases-item">
            <Form.Input
              name={`ModFourUsescases[${index}].title`}
              placeholder="Curso de la ESO"
              onChange={formik.handleChange}
              value={usesCase.title}
              error={
                formik.errors.ModFourUsescases?.[index]?.title
                  ? { content: formik.errors.ModFourUsescases[index].title }
                  : null
              }
            />

            {/* Editor de TinyMCE para la descripción */}
            <TiptapEditor
              content={usesCase.description}
              onChange={(content) =>
                formik.setFieldValue(
                  `ModFourUsescases[${index}].description`,
                  content,
                )
              }
            />
            {formik.errors.ModFourUsescases?.[index]?.description && (
              <div className="error-message">
                {formik.errors.ModFourUsescases[index].description}
              </div>
            )}

            <Button type="button" onClick={addCategory}>
              <Icon name="add" />
              Añadir Categoría
            </Button>
            <Button
              type="button"
              color="red"
              onClick={() => removeCategory(index)}
            >
              <Icon name="trash" />
              Eliminar Categoría
            </Button>
          </div>
        ))}
      </div>

      {/* Videos */}
      <div className="video-container">
        <label>Videos</label>
        {formik.values.ModFourVideo.map((ModFourVideo, index) => (
          <div key={index} className="video-item">
            <Form.Input
              name={`ModFourVideo[${index}]`}
              placeholder="URL del video"
              onChange={formik.handleChange}
              value={ModFourVideo}
              error={
                formik.errors.ModFourVideo?.[index]
                  ? { content: formik.errors.ModFourVideo[index] }
                  : null
              }
            />
            <Button type="button" onClick={addVideo}>
              <Icon name="add" />
              Añadir URL Video
            </Button>
            <Button
              type="button"
              color="red"
              onClick={() => removeVideo(index)}
            >
              <Icon name="trash" />
              Eliminar URL Video
            </Button>
          </div>
        ))}
      </div>

      <Form.Group>
        <Button
          type="button"
          onClick={prevStep}
          color="orange"
          style={{ width: "33.3333%" }}
        >
          Anterior
        </Button>
        <Button
          type="submit"
          primary
          style={{
            width: isUpdateMode ? "33.3333%" : "66.6666%",
            marginLeft: isUpdateMode ? "auto" : "33.3333%",
          }}
          loading={formik.isSubmitting}
        >
          Subir
        </Button>
        {isUpdateMode && (
          <Button
            type="button"
            onClick={nextStep}
            color="green"
            style={{ width: "33.3333%" }}
          >
            Siguiente
          </Button>
        )}
      </Form.Group>
    </Form>
  );
}
